import React from 'react'
import Card from '../../../reusableComponents/cards/Card71'
import ChangePasswordLabels from './ChangePasswordLabels'

const ChangePassword = () => {
  return (
    <div>
        <Card
            title="Change Password"
            showTitle={true}
            showPrimaryButton={false}
            showSecondaryButton={false}
            showMenuButton={false}
            showSwapComponent1={true}
            showSwapComponent2={false}
            showSwapComponent3={false}
            showDescription={false}
            primaryButtonComponent={null}
            secondaryButtonText="Button"
            description="Optional description can be added here"
            swapContent1={<ChangePasswordLabels />}
            swapContent2={null}
            swapContent3={null}
            swapLabel1="Change Password"        
        />
    </div>
  )
}

export default ChangePassword